import { render, staticRenderFns } from "./FlashDeals.vue?vue&type=template&id=ab32a11a&scoped=true"
import script from "./FlashDeals.vue?vue&type=script&lang=js"
export * from "./FlashDeals.vue?vue&type=script&lang=js"
import style0 from "./FlashDeals.vue?vue&type=style&index=0&id=ab32a11a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab32a11a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VRow})
